import "./App.scss";
import Navigation from "./components/navigation/Navigation.tsx";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Home from "./routes/home/Home.tsx";
import React from "react";
import Cybertracker from "./routes/projects/cybertracker/Cybertracker.tsx";
import Footer from "./components/footer/Footer.tsx";
import Mayor1551 from "./routes/projects/mayor-1551/Mayor1551.tsx";
import ECherha from "./routes/projects/e-cherha/E-cherha.tsx";
import Eroad from "./routes/projects/e-road/E-road.tsx";
import { EServicesNames } from "./components/services/const.ts";
import { HelmetProvider } from "react-helmet-async";
import NotFound from "./components/not-found/NotFound.tsx";
import TechSolutions from "./routes/solutions/tech-solutions/TechSolutions.tsx";
import WhoWeAre from "./routes/who-we-are/WhoWeAre.tsx";
import Partnership from "./routes/partnership/Partnership.tsx";
import Contacts from "./routes/contacts/Contacts.tsx";
import Faq from "./routes/faq/Faq.tsx";
import Blogs from "./routes/blogs/Blogs.tsx";
import Blog from "./routes/blogs/blog/Blog.tsx";
import Author from "./routes/autor/Author.tsx";
import Logistics from "./routes/solutions/logistics/Logistics.tsx";
import Solutions from "./routes/solutions/Solutions.tsx";
import PrivacyPolicy from "./routes/privacy-policy/PrivacyPolicy.tsx";
import CookiesWrapper from "./ui/components/cookies/CookiesWrapper.tsx";
import Services from "./routes/services/Services.tsx";
import HealthCare from "./routes/health-care/HealthCare.tsx";
import FinanceAndBanking from "./routes/finance-and-banking/FinanceAndBanking.tsx";
import ERPForLogistics from "./routes/solutions/erp-for-logistics/ErpForLogistics.tsx";
import BISystems from "./routes/solutions/bi-systems/BISystems.tsx";
import ErpSoftwareDev from "./routes/services/erp-software-dev/ErpSoftwareDev.tsx";
import CrmSoftwareDev from "./routes/services/crm-software-dev/CrmSoftwareDev.tsx";
import PublicSectors from "./routes/industries/public-sectors/PublicSectors.tsx";
import Startup from "./routes/industries/startup/Startup.tsx";
import SmartWarehouse from "./routes/solutions/smart-warehouse/SmartWarehouse.tsx";
import GoGoBag from "./routes/projects/go-go-bag/GoGoBag.tsx";
import Syvi from "./routes/projects/syvi/Syvi.tsx";
import RealEstate from "./routes/industries/real-estate/RealEstate.tsx";
import LifeInsurance from "./routes/industries/life-insurance/LifeInsurance.tsx";
import ECommerce from "./routes/industries/e-commerce/ECommerce.tsx";
import Retail from "./routes/industries/retail/Retail.tsx";
import Horeca from "./routes/industries/horeca/Horeca.tsx";
import ErpForUtilityCompanies from "./routes/solutions/erp-for-utility-companies/ErpForUtilityCompanies.tsx";
import ErpForPharma from "./routes/solutions/erp-for-pharma/ErpForPharma.tsx";
import ProjectManagementSystem from "./routes/solutions/project-management-system/ProjectManagementSystem.tsx";
import FleetManagementSystem from "./routes/solutions/fleet-management-system/FleetManagementSystem.tsx";
import CargoTrackingSystem from "./routes/solutions/cargo-tracking-system/CargoTrackingSystem.tsx";
import RoutePlanningSystem from "./routes/solutions/route-planning-system/RoutePlanningSystem.tsx";
import CrmForLogistics from "./routes/solutions/crm-for-logistics/CrmForLogistics.tsx";
import EhrEmrSoftwareDevelopment from "./routes/solutions/ehr-emr-software-development/EhrEmrSoftwareDevelopment.tsx";
import LimsSolutions from "./routes/solutions/lims-solutions/LimsSolutions.tsx";
import ScadaSolutions from "./routes/solutions/scada-solutions/ScadaSolutions.tsx";
import ProductionProcessMonitoringSystems
  from "./routes/solutions/production-process-monitoring-systems/ProductionProcessMonitoringSystems.tsx";
import CrmForEnergySector from "./routes/solutions/crm-for-energy-sector/CrmForEnergySector.tsx";
import AccountingAndBillingSystemsDevelopment
  from "./routes/solutions/accounting-and-billing-systems-development/AccountingAndBillingSystemsDevelopment.tsx";
import RoadConditionMonitoringSystems
  from "./routes/solutions/road-condition-monitoring-systems/RoadConditionMonitoringSystems.tsx";
import RoadMachineryControlSystems from "./routes/solutions/road-machinery-control-systems/RoadMachineryControlSystems.tsx";
import ProcurementSoftwareSolution from "./routes/solutions/procurement-software-solution/ProcurementSoftwareSolution.tsx";
import IotSolutionDevelopmentServices
  from "./routes/solutions/iot-solution-development-services/IotSolutionDevelopmentServices.tsx";
import SoftwareDevelopmentServices from "./routes/services/software-development-services/SoftwareDevelopmentServices.tsx";
import SoftwareImplementationAndSupport
  from "./routes/services/software-implementation-and-support/SoftwareImplementationAndSupport.tsx";
import Telecommunications from "./routes/industries/telecommunications/Telecommunications.tsx";
import RoadEngineering from "./routes/industries/road-engineering/RoadEngineering.tsx";
import StrategicItConsulting from "./routes/services/strategic-it-consulting/StrategicItConsulting.tsx";
import StartupDevelopment from "./routes/services/startup-development/StartupDevelopment.tsx";
import ErpForFinance from "./routes/solutions/erp-for-financial-systems/ErpForFinancialSystems.tsx";

function App() {
  const location = useLocation();

  return (
    <HelmetProvider>
      <div>
        <Navigation />
        <CookiesWrapper />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/case-study/cybertracker" element={<Cybertracker />} />
          <Route path="/case-study/1551" element={<Mayor1551 />} />
          <Route path="/case-study/e-cherha" element={<ECherha />} />
          <Route path="/case-study/e-road" element={<Eroad />} />
          <Route path="/case-study/go-go-bag" element={<GoGoBag />} />
          <Route path="/case-study/syvi" element={<Syvi />} />
          <Route
            path={`/services/${EServicesNames.CONSULTING}`}
            element={<Navigate to="/services/strategic-it-consulting" replace />}
          />
          <Route
            path={`/services/software-development`}
            element={<Navigate to="/services/software-development-services" replace />}
          />
          <Route
            path={`/services/software-development-services`}
            element={<SoftwareDevelopmentServices />}
          />
          <Route
            path={`/services/${EServicesNames.SUPPORT}`}
            element={<SoftwareImplementationAndSupport />}
          />
          <Route path={`/404`} element={<NotFound />} />
          <Route path="/industries" element={<TechSolutions />} />
          <Route path="/industries/public-sectors" element={<PublicSectors />} />
          <Route path="/industries/startup-product-engineering-expertise" element={<Startup />} />
          <Route path="/industries/real-estate" element={<RealEstate />} />
          <Route path="/industries/life-insurance" element={<LifeInsurance />} />
          <Route path="/industries/e-commerce" element={<ECommerce />} />
          <Route path="/industries/retail" element={<Retail />} />
          <Route path="/industries/horeca" element={<Horeca />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/erp-software-development-services" element={<ErpSoftwareDev/>} />
          <Route path="/services/crm-software-development-services" element={<CrmSoftwareDev/>} />
          <Route path="/services/strategic-it-consulting" element={<StrategicItConsulting/>} />
          <Route path="/services/startup-development" element={<StartupDevelopment/>} />
          <Route path="/industries/logistics-and-supply-chains" element={<Logistics />} />
          <Route path="/industries/healthcare" element={<HealthCare />} />
          <Route path="/industries/finance-and-banking" element={<FinanceAndBanking />} />
          <Route path="/industries/telecommunications" element={<Telecommunications />} />
          <Route path="/industries/road-engineering" element={<RoadEngineering />} />
          <Route path="/solutions/bi-systems" element={<BISystems />} />
          <Route path="/solutions/smart-warehouse-management" element={<SmartWarehouse />} />
          <Route path="/solutions/erp-for-financial-systems" element={<ErpForFinance />} />
          <Route path="/solutions/erp-for-logistics" element={<ERPForLogistics />} />
          <Route path="/solutions/erp-for-utility-companies" element={<ErpForUtilityCompanies />} />
          <Route path="/solutions/erp-for-pharma" element={<ErpForPharma />} />
          <Route path="/solutions/fleet-management-system" element={<FleetManagementSystem />} />
          <Route path="/solutions/project-management-system" element={<ProjectManagementSystem />} />
          <Route path="/solutions/cargo-tracking-system" element={<CargoTrackingSystem />} />
          <Route path="/solutions/route-planning-system" element={<RoutePlanningSystem />} />
          <Route path="/solutions/crm-for-logistics" element={<CrmForLogistics />} />
          <Route path="/solutions/ehr-emr-software-development" element={<EhrEmrSoftwareDevelopment />} />
          <Route path="/solutions/lims-solutions" element={<LimsSolutions />} />
          <Route path="/solutions/scada-solutions" element={<ScadaSolutions />} />
          <Route path="/solutions/production-process-monitoring-systems" element={<ProductionProcessMonitoringSystems />} />
          <Route path="/solutions/crm-for-energy-sector" element={<CrmForEnergySector />} />
          <Route path="/solutions/accounting-and-billing-systems-development" element={<AccountingAndBillingSystemsDevelopment />} />
          <Route path="/solutions/road-condition-monitoring-systems" element={<RoadConditionMonitoringSystems />} />
          <Route path="/solutions/road-machinery-control-systems" element={<RoadMachineryControlSystems />} />
          <Route path="/solutions/procurement-software-solution" element={<ProcurementSoftwareSolution />} />
          <Route path="/solutions/iot-solution-development-services" element={<IotSolutionDevelopmentServices />} />
          <Route path="/who-we-are" element={<WhoWeAre />} />
          <Route path="/partnership" element={<Partnership />} />
          <Route path="/contacts" element={<Contacts />} />
          <Route path="/frequently-asked-questions" element={<Faq />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blogs/:id" element={<Blog />} />
          <Route path="/authors/:id" element={<Author />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
        {location.pathname !== "/404" && <Footer />}
      </div>
    </HelmetProvider>
  );
}

export default App;
